import { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';

const ContactDealerInlineForm = lazy(() =>
    import(/* webpackChunkName: "ContactDealerInlineForm" */ './ContactDealerInlineForm')
);

export const ContactDealerInlineFormLoader = ({ load, ...props }) => {
    return (
        <>
            {load && (
                <Suspense fallback={''}>
                    <ContactDealerInlineForm {...props} />
                </Suspense>
            )}
        </>
    );
};

ContactDealerInlineFormLoader.propTypes = {
    load: PropTypes.bool,
};
